import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { mapAvailableFiltersToResults } from "../../../../utils/utils/map-available-filters-to-results.js";
import { useNoStoresResultsEvent } from "../../../hooks/use-no-stores-results-event.js";
import { STORES_SEARCH_WITH_INVENTORY } from "../../../../operations/queries/operations/queries/stores-search.js";
const useStoreSearchWithInventory = (variables, shouldFilterServicesNotAvailableAppointmentsAtStore) => {
  const { locale } = useIntl();
  const [query, queryState] = useLazyQuery(STORES_SEARCH_WITH_INVENTORY, {
    variables,
    context: {
      forwardHeaders: {
        "Accept-Language": locale
      }
    },
    errorPolicy: "all",
    fetchPolicy: "no-cache",
    onError(error) {
      toast.failed("stores.page.search.getStoresByDistance.error");
      console.error("Failed to search stores: ", error);
    }
  });
  const { availableFilters, filteredResults } = queryState.data ?? {};
  useNoStoresResultsEvent(filteredResults);
  const data = React.useMemo(
    () => mapAvailableFiltersToResults(
      availableFilters,
      filteredResults,
      shouldFilterServicesNotAvailableAppointmentsAtStore
    ),
    [availableFilters, filteredResults, shouldFilterServicesNotAvailableAppointmentsAtStore]
  );
  return React.useMemo(() => [query, { ...queryState, data }], [data, queryState, query]);
};
export {
  useStoreSearchWithInventory as default
};
//# sourceMappingURL=use-stores-search-with-inventory.js.map
